// German (de-DE) number/currency formatting — matches the prototype exactly.

const nf0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
const nf2 = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const nfPlain = new Intl.NumberFormat('de-DE');

/** €1.234 (no decimals). */
export const eur0 = (n: number): string => '€' + nf0.format(n);
/** €1.234,56 (two decimals). */
export const eur2 = (n: number): string => '€' + nf2.format(n);
/** 1.234 (no currency). */
export const num0 = (n: number): string => nfPlain.format(n);
/** 3,69× */
export const roasF = (n: number): string => n.toFixed(2).replace('.', ',') + '×';
/** 12,3 % */
export const pctF = (n: number): string => n.toFixed(1).replace('.', ',') + ' %';
